import React, { useContext } from "react";
import Img from "gatsby-image";
import PageSectionContainer from "./common/page-section-container";
import PageSectionHeading from "./common/page-section-heading"; // @ts-ignore
import AuthorNames from "./author-names";
import SubscriptionBadge, { SubscriptionBadgeSize } from "./badge/subscription-badge";
import AuthContext from "../services/firebase/auth-context/provider";
import { hasAccessToArticle } from "../util/subscription/access";
import { replaceQuotationMarksWithGuillemets } from "../util/format/guillemets";
var ArticleListItem = function ArticleListItem(_ref) {
    var to = _ref.to, title = _ref.title, authors = _ref.authors, _ref$authorLinks = _ref.authorLinks, authorLinks = _ref$authorLinks === void 0 ? true : _ref$authorLinks, excerpt = _ref.excerpt, image = _ref.image, smallTitle = _ref.smallTitle, _ref$isEdition = _ref.isEdition, isEdition = _ref$isEdition === void 0 ? true : _ref$isEdition, containerStyle = _ref.containerStyle, index = _ref.index, children = _ref.children, className = _ref.className, smallTitleClassName = _ref.smallTitleClassName, _ref$slider = _ref.slider, slider = _ref$slider === void 0 ? false : _ref$slider, _ref$frontPage = _ref.frontPage, frontPage = _ref$frontPage === void 0 ? false : _ref$frontPage, visibility = _ref.visibility, articleId = _ref.articleId;
    var _useContext$ = useContext(AuthContext)[0], authenticated = _useContext$.authenticated, user = _useContext$.user, userClaims = _useContext$.userClaims;
    var computedStyle = index != undefined && !slider ? index % 3 === 0 ? "md:pr-4" : index % 3 === 1 ? "md:pl-2 md:pr-2" : "md:pl-4" : "";
    var computedWidth = index != undefined && !slider && !frontPage ? "md:w-1/3" : "";
    var withBackgroundImage = slider && index % 3 === 0 || frontPage && (index === 0 || index === 5 || index === 6 || index === 11);
    var backgroundImage = withBackgroundImage ? image.src : "";
    smallTitleClassName = smallTitleClassName != undefined ? smallTitleClassName : withBackgroundImage || frontPage && (index === 1 || index === 4 || index === 7 || index === 10) ? "text-white-important" : "";
    var textColor = frontPage && (index === 1 || index === 4 || index === 7 || index === 10) || withBackgroundImage ? "text-white" : "";
    var containerBgColor = slider ? index % 3 === 1 ? "bg-makroBlueLight" : index % 3 === 2 ? "bg-makroOrangeLight" : "" : "";
    if (frontPage) {
        if (isEdition) {
            containerBgColor = index === 1 || index === 7 ? "bg-makroBlue" : index === 4 || index === 10 ? "bg-makroOrange" : "";
        }
        else {
            containerBgColor = index === 1 || index === 7 ? "bg-makroRedPortuguese" : index === 4 || index === 10 ? "bg-makroGreen" : "";
        }
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap mb-8 w-full " + computedWidth + " " + computedStyle + " " + className
    }, children, /*#__PURE__*/ React.createElement(PageSectionContainer, {
        to: to,
        className: containerStyle + " " + containerBgColor + " relative h-full",
        backgroundImage: backgroundImage
    }, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        title: smallTitle,
        className: smallTitleClassName + " " + (!hasAccessToArticle(userClaims, authenticated, visibility, articleId, user === null || user === void 0 ? void 0 : user.email) ? "pr-12" : "")
    }), articleId && evaluateSubscriptionBadge(visibility, isEdition, subscriptionBadgeShouldBeWhite(frontPage, containerBgColor), articleId), /*#__PURE__*/ React.createElement("div", {
        className: "px-4 md:pl-8 md:pr-5 flex-1 " + textColor
    }, title && /*#__PURE__*/ React.createElement("h3", {
        className: "text-2xl font-medium mt-3 mb-4"
    }, replaceQuotationMarksWithGuillemets(title)), /*#__PURE__*/ React.createElement(AuthorNames, {
        authors: authors,
        link: authorLinks
    }), excerpt && /*#__PURE__*/ React.createElement("div", {
        className: "mt-4",
        dangerouslySetInnerHTML: {
            __html: excerpt
        }
    })), image !== undefined && !slider && !frontPage && /*#__PURE__*/ React.createElement("div", {
        className: "mt-6"
    }, /*#__PURE__*/ React.createElement(Img, {
        fluid: image
    }))));
};
var evaluateSubscriptionBadge = function evaluateSubscriptionBadge(visibility, isEdition, white, articleId) {
    return /*#__PURE__*/ React.createElement(SubscriptionBadge, {
        size: SubscriptionBadgeSize.BOX,
        articleId: articleId,
        visibility: visibility,
        isEdition: isEdition,
        white: white,
        containerClasses: "absolute top-0 right-0"
    });
};
var subscriptionBadgeShouldBeWhite = function subscriptionBadgeShouldBeWhite(frontPage, containerBgColor) {
    return frontPage && containerBgColor !== "";
};
export default ArticleListItem;
